import { axiosAuthInstance } from "../../../config/axios-config";

var InterswitchService = {
  getInterswitchBillers: async function () {
    return await axiosAuthInstance.get("/interswitch-billers").then((res) => {
      return res.data;
    });
  },

  getInterswitchBillerCategories: async function () {
    return await axiosAuthInstance
      .get("/interswitch-billers/categories")
      .then((res) => {
        return res.data;
      });
  },
  getInterswitchBillerCategoryId: async function (id) {
    return await axiosAuthInstance
      .get(`/interswitch-billers/categories/${id}/billers`)
      .then((res) => {
        return res.data;
      });
  },
  getInterswitchBillerPaymentItems: async function (id) {
    return await axiosAuthInstance
      .get(`/interswitch-billers/${id}/payment-items`)
      .then((res) => {
        return res.data;
      });
  },
};

export default InterswitchService;
